<div class="back-button">
  <button matIconButton [routerLink]="'..'" [aria-label]="'back' | translate">
    <mat-icon matPrefix fontSet="material-symbols-rounded">arrow_back</mat-icon>
  </button>
</div>

<form class="wrapper" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
  <div class="register-form">
    <h1>{{ 'registerAccount' | translate }}</h1>

    @if (emailError()) {
      <div class="error-message">
        <mat-icon fontSet="material-symbols-rounded">error</mat-icon>
        <span>{{ emailError() }}</span>
      </div>
    }

    @if (emailVerifying() && !showEmailOtp() && !showPasswordLogin()) {
      <div class="user-welcome shimmer">
        <div class="welcome-label skeleton-text"></div>
        <div class="email-chip skeleton-chip"></div>
      </div>
    }

    <div class="form-content-wrapper">
      @if (!showEmailOtp() && !showPasswordLogin()) {
        <!-- Identity Discovery -->
        <mat-form-field>
          <mat-icon matPrefix fontSet="material-symbols-rounded">home</mat-icon>
          <mat-label>{{ 'email' | translate }}</mat-label>
          <input matInput type="email" autocomplete="username" formControlName="email" />
          @if (registerForm.get('email')?.hasError('email')) {
            <mat-error>{{ 'invalidEmail' | translate }}</mat-error>
          }
        </mat-form-field>

        <button
          mat-flat-button
          type="submit"
          [disabled]="emailVerifying() || !isEmailValid()"
        >
          @if (emailVerifying()) {
            <mat-spinner [diameter]="20"></mat-spinner>
          } @else {
            {{ 'next' | translate }}
          }
        </button>
      } @else if (showPasswordLogin()) {
        <!-- Existing User: Password Flow -->
        <input type="hidden" autocomplete="username" [value]="$safeNavigationMigration(registerForm.get('email')?.value)" />
        <div class="user-welcome">
          <span class="welcome-label">{{ 'signingInAs' | translate }}</span>
          <div class="email-chip">
            <mat-icon fontSet="material-symbols-rounded" class="chip-icon">alternate_email</mat-icon>
            <span class="email-value">{{ registerForm.get('email')?.value }}</span>
            <button mat-icon-button type="button" (click)="resetEmailAuth()" class="small-icon-button">
              <mat-icon fontSet="material-symbols-rounded">edit</mat-icon>
            </button>
          </div>
        </div>

        <mat-form-field>
          <mat-icon matPrefix fontSet="material-symbols-rounded">key</mat-icon>
          <mat-label>{{ 'password' | translate }}</mat-label>
          <input
            #passwordInput
            matInput
            autocomplete="current-password"
            [type]="hidePassword() ? 'password' : 'text'"
            formControlName="password"
          />
          <button
            mat-icon-button
            matSuffix
            (click)="hidePassword.set(!hidePassword())"
            type="button"
          >
            <mat-icon fontSet="material-symbols-rounded">{{
              hidePassword() ? 'visibility_off' : 'visibility'
            }}</mat-icon>
          </button>
        </mat-form-field>

        <button
          mat-flat-button
          type="submit"
          [disabled]="loginLoading() || registerForm.get('password')?.invalid"
        >
          @if (loginLoading()) {
            <mat-spinner [diameter]="20"></mat-spinner>
          } @else {
            {{ 'login' | translate }}
          }
        </button>

        <button mat-button type="button" class="text-link-button" (click)="sendEmailOtp()">
          {{ 'useEmailCodeInstead' | translate }}
        </button>
      } @else if (showEmailOtp()) {
        <!-- New/OTP User: OTP Flow -->
        <div class="user-welcome">
          <span class="welcome-label">{{ 'signingInAs' | translate }}</span>
          <div class="email-chip">
            <mat-icon fontSet="material-symbols-rounded" class="chip-icon">alternate_email</mat-icon>
            <span class="email-value">{{ registerForm.get('email')?.value }}</span>
            <button mat-icon-button type="button" (click)="resetEmailAuth()" class="small-icon-button">
              <mat-icon fontSet="material-symbols-rounded">edit</mat-icon>
            </button>
          </div>
        </div>

        <p class="otp-sent-message">
          {{ 'otpSentMessage' | translate: {email: $safeNavigationMigration(registerForm.get('email')?.value)} }}
        </p>

        <otg-otp-input
          [loading]="emailVerifying()"
          [error]="emailError()"
          [resendCountdown]="emailResendCountdown()"
          (codeChange)="emailOtpCode.set($event)"
          (codeCompleted)="verifyEmailOtp($event)"
          (resendRequested)="sendEmailOtp()"
        ></otg-otp-input>

        <button
          mat-flat-button
          type="submit"
          [disabled]="emailVerifying() || emailOtpCode().length < 6"
        >
          @if (emailVerifying()) {
            <mat-spinner [diameter]="20"></mat-spinner>
          } @else {
            {{ 'confirm' | translate }}
          }
        </button>
      }
    </div>

    <p class="login-link">
      {{ 'alreadyHaveAnAccount' | translate }}
      <a routerLink="/login">{{ 'login' | translate }}</a>
    </p>
  </div>

  @if (logoPath$ | async; as logoPath) {
    <img [src]="logoPath" width="50" alt="Register organisation logo" class="logo" />
  } @else {
    <img src="assets/logo_light.png" alt="Register organisation logo" width="100" priority />
  }
</form>
